import Config from "react-native-config";
import { APIService } from "../utilities/Constants";
import { Logger } from "../utilities/HelperFunctions";
import { apiGet, apiPost, apiPut } from "./utils/apiUtils";
import { messages } from "../../src/resources/strings";

//API :: Get notification list
export const getNotifications = async () => {
  const response = await apiGet<any>(
    APIService.notificationService,
    `/notifications`,
    {}
  );

  const notificationList = response;
  if (notificationList.length == 0) {
    return {
      errorCode: messages.error.noNotificationFound,
    };
  } else if (notificationList.errorCode) {
    return {
      errorCode: notificationList.errorCode,
    };
  } else {
    return {
      response: notificationList,
      errorCode: messages.error.noError,
    };
  }
};

//API :: Update notification list
export const updateNotifications = async (
  isRead: boolean,
  notificationId: string
) => {
  const params = JSON.stringify({
    read: isRead,
  });
  const response = await apiPost(
    APIService.harmony,
    `/notify/${notificationId}`,
    params,
    {}
  );

  if (response.status === 200) {
    Logger("Notification updated successfully");
  } else {
    Logger("Notification updation failed");
  }
};

//API :: Delete notification list
export const deleteNotifications = async (notificationId: string) => {
  const response = await apiGet<any>(
    APIService.notificationService,
    `/notification/${notificationId}`,
    {}
  );

  if (response.status === 200) {
    return {
      response: true,
      errorCode: messages.error.noError,
    };
  } else {
    return {
      errorCode: messages.error.somthingWrong,
    };
  }
};

//API :: Firebase Token from APNS for iOS
export const fetchFirebaseTokenFromApnsForiOS = async (param: any) => {
  const params = JSON.stringify({
    application: Config.REACT_APP_IOS_BUNDLE_ID,
    sandbox: false,
    apns_tokens: [param.apnsToken],
  });

  const response = await apiPost(
    APIService.harmony,
    `/firebase/deviceToken`,
    params,
    {}
  );

  if (response.status === 200) {
    return response.data[0].registration_token;
  } else {
    return null;
  }
};
